module.exports = __webpack_public_path__ + "img/sign-77.27a704d8.jpg";